// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UnsubscribeForm-module--wrapper--1Q3wh","titleWrapp":"UnsubscribeForm-module--titleWrapp--3vs0z","inputWrapp":"UnsubscribeForm-module--inputWrapp--2m2lC"};